/* @flow */

import chunk from 'lodash/chunk';
import React from 'react';
import { render } from 'react-dom';
import { type TotaisEtapas } from '../types';
import { type StateColors } from '../../utils/types';
import formatarRealComMoeda from '../../utils/formatar-real-com-moeda';

type Props = {
    etapas: TotaisEtapas[],
}

const Item = ({
    etapa,
    valor,
    cor,
    porcentagem,
    contagem,
}: {
    etapa: string,
    valor: number,
    cor: StateColors,
    porcentagem: number,
    contagem: number,
}) => (
    <div className="m-widget15__item">
        <span className="m-widget15__stats">{etapa}</span>
        <span
            className="m-widget15__text"
            style={{ float: 'initial', marginLeft: '10px', fontSize: '9pt' }}
        >
            {`(${contagem})`}
        </span>
        <span
            className="m-widget15__text"
            style={{ float: 'initial', marginLeft: '10px' }}
        >
            <b style={{ fontWeight: '600', fontSize: '1.1rem' }}>
                {formatarRealComMoeda(valor)}
            </b>
        </span>
        <span
            className="m-widget15__text"
            style={{ float: 'right', fontSize: '13px' }}
        >
            <b>{`${porcentagem.toFixed(2)}%`}</b>
        </span>
        <div className="m--space-10" />
        <div className="progress m-progress--sm">
            <div
                className={`progress-bar bg-${cor}`}
                role="progressbar"
                style={{
                    width: `${porcentagem}%`,
                    // backgroundColor: `${etapa === 'Aguardando Aprovação' ? '#af5bf1' : ''}`,
                }}
            />
        </div>
    </div>
);

const Row = ({ etapas }: Props) => (
    <div className="row">
        {etapas.map(etapa => (
            <div className="col">
                <Item {...etapa} />
            </div>
        ))}
    </div>
);

const Totais = ({ etapas }: Props) => (
    <div className="m-widget15__items">
        {chunk(etapas, 4).map(pedaco => (
            <Row
                etapas={pedaco}
            />
        ))}
    </div>
);

const MontarWidgetTotais = (
    etapas: TotaisEtapas[],
) => {
    const root = document.getElementById('root');
    if (root) {
        render(<Totais etapas={etapas} />, root);
    }
};

export default MontarWidgetTotais;
